/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {Endpoints} from '@app/Endpoints';
import http from '@app/lib/HttpClient';
import {Logger} from '@app/lib/Logger';
import UserStore from '@app/stores/UserStore';
import type {User} from '@fluxer/schema/src/domains/user/UserResponseSchemas';

const logger = new Logger('TermsAcceptance');

export async function acceptTerms(): Promise<void> {
	try {
		const response = await http.post<User>(Endpoints.USER_TERMS_ACCEPTANCE);
		UserStore.handleUserUpdate(response.body, {clearMissingOptionalFields: true});
		logger.info('Terms and privacy policy accepted');
	} catch (error) {
		logger.error('Failed to accept terms', error);
		throw error;
	}
}
